export const FLAG_GETTING_BUS_ACTIVITY_HISTORY =
  'FLAG_GETTING_BUS_ACTIVITY_HISTORY';
export const GET_BUS_ACTIVITY_HISTORY = 'GET_BUS_ACTIVITY_HISTORY';
export const CLEAR_BUS_ACTIVITY_HISTORY = 'CLEAR_BUS_ACTIVITY_HISTORY';
